import { render } from "./FormTemplates.vue?vue&type=template&id=04afec57&scoped=true"
import script from "./FormTemplates.vue?vue&type=script&lang=js"
export * from "./FormTemplates.vue?vue&type=script&lang=js"

import "./FormTemplates.vue?vue&type=style&index=0&id=04afec57&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04afec57"]])

export default __exports__